import React from "react";
import GaugeChart from "react-gauge-chart/dist/GaugeChart";
import { addTopic, removeTopic } from "../../utils/socket.services";
import { getOneThing, imageAddress } from "../../utils/useful";


class StatusSwitcherWidget extends React.Component {

    state = {
        data: {},
        thing: {},
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data?.thing != this.props.data?.thing) {
            this.init()
        }
    }

    componentWillUnmount() {
        removeTopic(this.state.topicId, this.props.data.thing, 'things')
    }

    init() {
        this.setState({ thing: {}, data: {} }, () => {
            getOneThing({ id: this.props.data.thing }, (fetchResult, fetchError, status) => {
                // console.log(fetchResult)
                if (fetchResult) {
                    this.setState({ thing: fetchResult.info, data: fetchResult.info.latestData ?? {} })
                }

                addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)
            })
        })
    }


    updateData = (newData) => {
        let data = this.state.data
        data = { ...data, ...newData }
        this.setState({ data })
        // console.log("updateData")
    }


    getLabel(dataObject) {
        // console.log(dataObject)
        if (this.state.thing?.structure) {
            // let result = ''
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject == dataObject) {
                    return structure.label
                }
            }

        }
    }


    chooseImage(value){

        // console.log(this.props.data)
        let image = '/images/idea.svg'
        for (let i = 0; i < this.props.data.status.length; i++) {
            const element = this.props.data.status[i];
            // console.log(element.value)
            // console.log(value)
            if(String(element.value) == String(value)){
                // console.log("OKK")
                image = imageAddress(element.icon,'profile','small')
            }
        }

        return image
        // '/images/idea.svg'
    }


    render() {
        return (
            <div className="w-100 flexcc py-3" style={{ flex: 1, flexDirection: 'column' }} >
                <div className={"text-center mb-2 "} >
                    <div style={{}}>
                        {/* <p className="text-bold " style={{ fontSize: 30 }}>27.4</p> */}
                        <img src={this.chooseImage(this.state.data[this.props.data.characteristic])} height="80px" />
                        <p className="text-normal text-bold mt-2">{this.state.data[this.props.data.characteristic]}</p>
                        <p className="text-small ">{this.getLabel(this.props.data.characteristic)}</p>

                        {/* <p className="text-small">{JSON.stringify(this.state.data)}</p> */}

                        {/* {this.props.data.description && (<p className="text-smaller" style={{ color: '#F87C56b7fb7f' }}>{this.props.data.description}</p>)} */}

                    </div>
                </div>
            </div>
        )
    }
}



export default StatusSwitcherWidget;
